/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable eqeqeq */
/* eslint-disable jsx-a11y/alt-text */
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as SERVICE from '../../../constants/service.types';
import * as ACTIONS from '../../../redux/actions';
import { socketEmitEvent } from '../../../redux/actions';
import {
  Badge,
  Button,
  Col,
  Collapse,
  Empty,
  List,
  Modal,
  Progress,
  Row,
  Select,
  Spin,
} from 'antd';
import {
  LoadingOutlined,
  MinusOutlined,
  PlusOutlined,
} from '@ant-design/icons';
import classNames from 'classnames';
import IconNotificationOff from '../../../assets/icons/notification_off.svg';
import AlertNotification from '../../../assets/icons/alert.svg';
import CameraTampering from '../../../assets/icons/camera_tampered.svg';
import EventObjectDetectionNotification from '../../../assets/icons/event_detect.svg';
import UpdateSystemNotification from '../../../assets/icons/update_system.svg';
import AddDeviceNotification from '../../../assets/icons/add_service.svg';
import RemoveDeviceNotification from '../../../assets/icons/remove_device.svg';
import DisconnectedDeviceNotification from '../../../assets/icons/disconnect_device.svg';
import AdvertiseNotification from '../../../assets/icons/advertise.svg';
import PeopleNotification from '../../../assets/icons/people_notif.svg';
import CarNotification from '../../../assets/icons/car_noti.svg';
import KnifeNotification from '../../../assets/icons/knife_noti.svg';
import MotobikeNotification from '../../../assets/icons/motobike_noti.svg';
import SungNotification from '../../../assets/icons/sung_noti.svg';
import Expand from 'react-expand-animated';
import { useTranslation } from 'react-i18next';
import InfiniteScroll from 'react-infinite-scroller';
import moment from 'moment';
import { beeXLogger } from '../../../helpers/logger';

const { Option } = Select;

const NotificationTestComponent = ({ data }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const { Panel } = Collapse;
  const [open, setOpen] = useState(false);
  const [percent, setPercent] = useState(0);
  const [dataNotification, setDataNotification] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [dataDetail, setDataDetail] = useState();
  const { isAuth, notifications, namespace, listAlert } = useSelector(
    (state) => state,
  );

  useEffect(() => {
    let requestId = new Date().getTime();
    if (isAuth === 1 && namespace) {
      let data = {
        timeRequested: requestId,
        page: 1,
        namespace,
      };
      let dataObj = {
        appServiceType: SERVICE.LIST_NOTIFICATION,
        requestId,
        body: JSON.stringify(data),
      };
      dispatch(socketEmitEvent(dataObj));
    }
  }, [dispatch, isAuth, namespace]);

  useEffect(() => {
    let requestId = new Date().getTime();
    if (isAuth === 1 && namespace) {
      let data = {
        timeRequested: requestId,
        namespace,
      };
      let dataObj = {
        appServiceType: SERVICE.MARK_READ_NOTIFICATION,
        requestId,
        body: JSON.stringify(data),
      };
      dispatch(socketEmitEvent(dataObj));
    }
  }, [dispatch, isAuth, namespace]);

  useEffect(() => {
    if (percent === 100) {
      setTimeout(() => {
        setPercent(0);
      }, 1000);
    }
  }, [percent]);

  useEffect(() => {
    if (notifications) {
      beeXLogger.debug('Notifications: ', notifications);
      const temple = notifications;
      setDataNotification((prev) =>
        orderDate(
          Array.from(
            new Map(
              [...prev, ...temple].map((item) => [item.id, item]),
            ).values(),
          ),
        ),
      );
    }
  }, [notifications]);

  const orderDate = (arr) => {
    arr.sort(function (a, b) {
      return moment(b.updatedAt).valueOf() - moment(a.updatedAt).valueOf();
    });
    return arr;
  };

  const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

  const renderLoading = useMemo(() => {
    const temple = isLoading && hasMore && (
      <div
        className="demo-loading-container"
        style={{ display: 'flex', justifyContent: 'center' }}
      >
        <Spin indicator={antIcon} />
      </div>
    );
    return temple;
  }, [isLoading, hasMore]);

  const updateStatus = useCallback(
    (item) => {
      if (item.status == 1) {
        let requestId = new Date().getTime();
        item.status = 3;
        let data = {
          timeRequested: requestId,
          notificationId: item.id,
          status: 3,
          namespace,
        };
        let dataObj = {
          appServiceType: SERVICE.UPDATE_NOTIFICATION,
          requestId,
          body: JSON.stringify(data),
        };
        dispatch(socketEmitEvent(dataObj));
      }
      return item;
    },
    [dispatch],
  );

  const onHandleLoadMore = useCallback(
    (val) => {
      setIsLoading(true);
      let requestId = new Date().getTime();
      if (isAuth === 1 && namespace) {
        let data = {
          timeRequested: requestId,
          page: val,
          namespace,
        };
        let dataObj = {
          appServiceType: SERVICE.LIST_NOTIFICATION,
          requestId,
          body: JSON.stringify(data),
        };
        setTimeout(() => {
          dispatch(socketEmitEvent(dataObj));
          setIsLoading(false);
        }, 1000);
      }
    },
    [isLoading, isAuth, namespace, dispatch],
  );

  const handleChange = useCallback(
    (item, value) => {
      let dataInfo = (item?.extraInfo && JSON.parse(item.extraInfo)) || {};
      dataInfo.errorCode = value;
      item.status = 3;
      let data = {
        notificationId: item.id,
        status: 3,
        namespace,
        extraInfo: JSON.stringify({ ...dataInfo }),
      };
      let dataObj = {
        appServiceType: SERVICE.UPDATE_NOTIFICATION,
        requestId: new Date().getTime(),
        body: JSON.stringify(data),
      };
      setTimeout(() => {
        setPercent(100);
      }, 400);
      dispatch(socketEmitEvent(dataObj));
    },
    [dispatch],
  );

  const svgPrefixNotification = (item) => {
    var temple = '';
    switch (item.type) {
      case 'alert':
        temple = <img src={AlertNotification} />;
        break;
      case 'event_object_detection':
        temple = <img src={EventObjectDetectionNotification} />;
        break;
      case 'warning_detection':
        temple = <img src={CameraTampering} />;
        break;
      case 'update_system':
        temple = <img src={UpdateSystemNotification} />;
        break;
      case 'add_device':
        temple = <img src={AddDeviceNotification} />;
        break;
      case 'remove_device':
        temple = <img src={RemoveDeviceNotification} />;
        break;
      case 'disconnected_device':
        temple = <img src={DisconnectedDeviceNotification} />;
        break;
      case 'advertise':
        temple = <img src={AdvertiseNotification} />;
        break;
      default:
        temple = <img src={AlertNotification} />;
        break;
    }
    return temple;
  };

  const contentNotification = (item) => {
    var temple = '';
    switch (item.type) {
      case 'event_object_detection':
        let array_object =
          item.extraInfo &&
          JSON.parse(item.extraInfo) &&
          JSON.parse(item.extraInfo).objects &&
          JSON.parse(item.extraInfo).objects.split(',');
        let key_object = {};
        array_object &&
          array_object.forEach((e) => {
            if (e == 'car') {
              key_object.car = true;
            }
            if (e == 'motor') {
              key_object.motor = true;
            }
            if (e == 'gun') {
              key_object.gun = true;
            }
            if (e == 'knife') {
              key_object.knife = true;
            }
            if (e == 'person') {
              key_object.person = true;
            }
          });
        temple = (
          <div>
            <span>{item.content}</span>
            {key_object.person ? (
              <img style={{ marginLeft: '10px' }} src={PeopleNotification} />
            ) : (
              ''
            )}
            {key_object.car ? (
              <img style={{ marginLeft: '5px' }} src={CarNotification} />
            ) : (
              ''
            )}
            {key_object.knife ? (
              <img style={{ marginLeft: '5px' }} src={KnifeNotification} />
            ) : (
              ''
            )}
            {key_object.motor ? (
              <img style={{ marginLeft: '5px' }} src={MotobikeNotification} />
            ) : (
              ''
            )}
            {key_object.knife ? (
              <img style={{ marginLeft: '5px' }} src={SungNotification} />
            ) : (
              ''
            )}
          </div>
        );
        break;
      case 'update_system':
        temple = <span>{t('System upgrade schedule')}</span>;
        break;
      default:
        temple = <span>{item.content}</span>;
    }
    return temple;
  };

  const extraInfoNotification = (item) => {
    var temple = '';
    switch (item.type) {
      case 'alert':
        temple = <div></div>;
        break;
      case 'event_object_detection':
        temple = (
          <div>
            <a>
              <img
                src={
                  item.extraInfo &&
                  JSON.parse(item.extraInfo) &&
                  (JSON.parse(item.extraInfo).imageUrl ??
                    JSON.parse(item.extraInfo).url)
                }
                style={{
                  width: '95%',
                  marginTop: '0.5rem',
                  marginLeft: '0.5rem',
                }}
                onClick={() => {
                  dispatch(
                    ACTIONS.popupVideoStorageFileByTimeReturn({
                      dataDetail: item,
                      isModalVisible: true,
                    }),
                  );
                }}
              />
            </a>
          </div>
        );
        break;
      case 'update_system':
        temple = (
          <div style={{ margin: '0.25rem 0 0 0.5rem' }}>
            <span style={{ fontSize: '12px', color: '#797979' }}>
              {t('Related effects')}:{' '}
              {item.content &&
                JSON.parse(item.content) &&
                JSON.parse(item.content).effect}
            </span>
          </div>
        );
        break;
      case 'add_device':
        temple = <div></div>;
        break;
      case 'remove_device':
        temple = <div></div>;
        break;
      case 'disconnected_device':
        temple = (
          <Row style={{ padding: '8px 8px 0px 8px' }}>
            <Col span={24}>
              <Select
                size="small"
                placeholder={t('Select reason')}
                style={{ width: '100%' }}
                defaultValue={
                  (item?.extraInfo && JSON.parse(item.extraInfo)?.errorCode) ||
                  undefined
                }
                onChange={(value) => handleChange(item, value)}
              >
                {listAlert?.map((item) => (
                  <Option value={item.errorCode}>{item.title}</Option>
                ))}
              </Select>
            </Col>
            {percent === 100 && (
              <Col span={24}>
                <Progress
                  style={{ width: '100%' }}
                  percent={percent}
                  size="small"
                />
              </Col>
            )}
          </Row>
        );
        break;
      case 'advertise':
        temple = (
          <div>
            <span style={{ fontSize: '12px', color: '#797979' }}>
              {t('App description')}:{' '}
              {item.extraInfo &&
                JSON.parse(item.extraInfo) &&
                JSON.parse(item.extraInfo).summary}
            </span>
          </div>
        );
        break;
      default:
    }
    return temple;
  };

  const toggle = (item) => {
    let stateCopy = { ...open };
    stateCopy[item.id] = !stateCopy[item.id];
    let dataObject = {};
    dataObject[item.id] = stateCopy[item.id];
    setOpen({ ...dataObject });
    setPercent(0);
  };

  const endFixIconNotif = (item) => {
    var icon_endfix = '';
    switch (item.type) {
      case 'alert':
        break;
      case 'event_object_detection':
        icon_endfix = (
          <span style={{ fontSize: '13px', color: '#0E9347' }}>
            {t('Image')}
          </span>
        );
        break;
      case 'update_system':
        icon_endfix = (
          <span>
            <span style={{ fontSize: '12px', color: '#797979' }}>CSKH: </span>
            <span style={{ fontSize: '12px', color: '#0E9347' }}>
              {item.content &&
                JSON.parse(item.content) &&
                JSON.parse(item.content).cskh}
            </span>
          </span>
        );
        break;
      case 'add_device':
        icon_endfix = <div></div>;
        break;
      case 'remove_device':
        icon_endfix = <div></div>;
        break;
      case 'disconnected_device':
        break;
      case 'advertise':
        icon_endfix = <div></div>;
        break;
      default:
    }
    return icon_endfix;
  };

  const onChangeAlert = useCallback(
    (extraInfo) => {
      if (namespace) {
        let dataBody = {
          namespace,
          deviceTypeId: (extraInfo && JSON.parse(extraInfo)?.deviceTypeId) || 3,
        };
        let dataObj = {
          appServiceType: SERVICE.LIST_ALERT,
          requestId: new Date().getTime(),
          body: JSON.stringify(dataBody),
        };
        dispatch(socketEmitEvent(dataObj));
      }
    },
    [namespace, dispatch],
  );

  const handleCancel = () => {
    setIsModalVisible(false);
    setDataDetail(undefined);
  };

  return (
    <div
      className="left-tab-component-label"
      style={{ height: '500px', overflow: 'auto', width: '335px' }}
    >
      {dataNotification && dataNotification.length > 0 ? (
        <InfiniteScroll
          initialLoad={false}
          pageStart={1}
          loadMore={onHandleLoadMore}
          hasMore={!isLoading && hasMore}
          useWindow={false}
          threshold={100}
        >
          <List
            id="list_item_notification"
            itemLayout="horizontal"
            dataSource={dataNotification}
            renderItem={(item) => (
              <List.Item>
                <div className="child-notification-component">
                  <div className="data-notification">
                    <a
                      className="content"
                      onClick={() => {
                        updateStatus(item);
                        onChangeAlert(item.extraInfo);
                      }}
                    >
                      <Row>
                        <Col span={3}>{svgPrefixNotification(item)}</Col>
                        <Col span={19} style={{ width: '300px' }}>
                          <p
                            className="text_content"
                            onClick={() => {
                              toggle(item);
                            }}
                          >
                            {contentNotification(item)}
                          </p>
                        </Col>
                        <Col span={2}>
                          {open[item.id] ? (
                            <MinusOutlined
                              onClick={() => {
                                toggle(item);
                              }}
                            />
                          ) : (
                            <PlusOutlined
                              onClick={() => {
                                toggle(item);
                              }}
                            />
                          )}
                        </Col>
                      </Row>
                    </a>
                  </div>
                  <div className="date-notification">
                    <div
                      className={classNames('status', {
                        new: item.status === 1,
                        old: item.status !== 1,
                      })}
                    >
                      {moment(item.updatedAt).format('HH:mm:ss DD-MM-YYYY')}
                      <Badge style={{ marginLeft: '10px' }} color={'white'} />
                      {endFixIconNotif(item)}
                    </div>
                    <div>
                      <Expand open={open[item.id]}>
                        {extraInfoNotification(item)}
                      </Expand>
                    </div>
                  </div>
                </div>
              </List.Item>
            )}
          />
          {renderLoading}
        </InfiniteScroll>
      ) : (
        <Empty
          style={{ margin: 80 }}
          image={IconNotificationOff}
          imageStyle={{
            height: 80,
          }}
          description={<span>{t('No Notifications!')}</span>}
        />
      )}
      <Modal
        className="modal-detail-notification"
        title={
          <div style={{ display: 'flex' }}>
            <div>{contentNotification(dataDetail ?? '')}</div>
            <div
              style={{
                color: '#797979',
                marginLeft: '8px',
                fontSize: '12px',
                marginTop: '3px',
              }}
            >
              {moment(dataDetail?.updatedAt).format('HH:mm:ss DD-MM-YYYY')}
            </div>
          </div>
        }
        visible={isModalVisible}
        onCancel={handleCancel}
        style={{ top: 50 }}
        width="920px"
        bodyStyle={{ textAlign: 'center' }}
        footer={[
          <Button key="back" onClick={handleCancel}>
            {t('Close')}
          </Button>,
        ]}
      >
        {dataDetail && (
          <img
            src={
              dataDetail.extraInfo &&
              JSON.parse(dataDetail.extraInfo) &&
              (JSON.parse(dataDetail.extraInfo).imageUrl ??
                JSON.parse(dataDetail.extraInfo).url)
            }
            style={{ height: '478px' }}
          />
        )}
      </Modal>
    </div>
  );
};

export default NotificationTestComponent;
